enum ContextEntityType {
  EVENT_SERIES = "EVENT_SERIES",
  REGISTRATION = "REGISTRATION",
  EVENT = "EVENT",
  PROGRAM = "PROGRAM",
  TICKET = "TICKET",
  BULK_TICKET = "BULK_TICKET",
  ORGANIZATION = "ORGANIZATION",
  PARTICIPANT = "PARTICIPANT",
  EVENT_PARTICIPANT = "EVENT_PARTICIPANT",
  PROGRAM_PARTICIPANT = "PROGRAM_PARTICIPANT",
  EVENT_AGENDA = "EVENT_AGENDA",
  SPONSOR = "SPONSOR",
  SPEAKER = "SPEAKER",
  PROGRAM_AGENDA = "PROGRAM_AGENDA",
  PROGRAM_ORGANIZATION = "PROGRAM_ORGANIZATION",
  CONTACT = "CONTACT",
  REGISTRATION_FORM = "REGISTRATION_FORM",
  EVENT_ORGANIZATION = "EVENT_ORGANIZATION",
  TABLETALK_TOPIC = "TABLETALK_TOPIC",
  REGISTRATION_PARTICIPANT = "REGISTRATION_PARTICIPANT"
}

export default ContextEntityType;
